import { useState } from 'react';
import styles from './Ritverktyg.module.css';
import classNames from 'classnames';

import Polygon from './Polygon';
import Cirkel from './Cirkel';
import Linje from './Linje';
import { IconButton } from '@mui/material';
import { BiCircle } from 'react-icons/bi';
import { FaDrawPolygon } from 'react-icons/fa';
import { MdLinearScale } from 'react-icons/md';
import { useKartstodContext } from '../contexts/KartstodContext';
import { usePremiumContext } from '../contexts/PremiumContext';
import ModalInfotext from '../ModalInfotext';
import { Create } from '@mui/icons-material';
import { grey } from '@mui/material/colors';

const Ritverktyg = () => {
  const {
    ritverktyg,
    setRitverktyg,
    geometri,
    setGeometri,
    isRitverktygAktiv,
    setIsRitverktygAktiv,
    setIsMarkeraAktiv,
  } = usePremiumContext();
  const {
    isRitverktygOpen,
    setIsRitverktygOpen,
    setIsInstallningarOpen,
    setIsSokKoordinaterOpen,
  } = useKartstodContext();
  const [visaHjalpRuta, setVisaHjalpRuta] = useState(false);

  const aktiveraCirkel = () => {
    setRitverktyg({
      isCirkel: !ritverktyg.isCirkel,
      isPin: false,
      isPolygon: false,
      isLinje: false,
    });
    setIsRitverktygOpen(false);

    if (ritverktyg.isCirkel) {
      setGeometri('pin');
      setIsRitverktygAktiv(false);
    } else {
      setGeometri('cirkel');
      setIsRitverktygAktiv(true);
    }
  };

  const aktiveraPolygon = () => {
    setRitverktyg({
      isPolygon: !ritverktyg.isPolygon,
      isPin: false,
      isCirkel: false,
      isLinje: false,
    });
    setIsRitverktygOpen(false);

    if (ritverktyg.isPolygon) {
      setGeometri('pin');
      setIsRitverktygAktiv(false);
    } else {
      setGeometri('polygon');
      setIsRitverktygAktiv(true);
    }
  };

  const aktiveraLinje = () => {
    setRitverktyg({
      isLinje: !ritverktyg.isLinje,
      isCirkel: false,
      isPolygon: false,
      isPin: false,
    });
    setIsRitverktygOpen(false);

    if (ritverktyg.isLinje) {
      setGeometri('pin');
      setIsRitverktygAktiv(false);
    } else {
      setGeometri('linje');
      setIsRitverktygAktiv(true);
    }
  };

  const togglaRitverktyg = () => {
    setIsRitverktygOpen(!isRitverktygOpen);
    setIsInstallningarOpen(false);
    setIsSokKoordinaterOpen(false);
    setVisaHjalpRuta(false);
    setIsMarkeraAktiv(false);

    if (geometri === '') {
      setGeometri('pin');
    }
  };

  const aktivtRitverktyg = () => {
    if (ritverktyg.isLinje) {
      return <MdLinearScale size="25" />;
    } else if (ritverktyg.isPolygon) {
      return <FaDrawPolygon size="25" />;
    } else if (ritverktyg.isCirkel) {
      return <BiCircle size="25" />;
    } else {
      return <Create />;
    }
  };

  const hovraHjalpRuta = () => {
    if (isRitverktygOpen || isRitverktygAktiv) {
      setVisaHjalpRuta(false);
    } else {
      setVisaHjalpRuta(true);
    }
  };

  const doljHjalpRuta = () => {
    setVisaHjalpRuta(false);
  };

  return (
    <>
      {visaHjalpRuta ? (
        <ModalInfotext
          meddelande={'Välj fastigheter med hjälp av en geometri'}
          style={{ top: '60px', width: '228px' }}
        />
      ) : null}
      <div
        className={classNames(
          styles.drawToolsContainer,
          isRitverktygOpen ? styles.drawToolsContainerActive : styles.shrinkIcon
        )}
      >
        <div
          className={classNames(
            styles.tool,
            isRitverktygAktiv ? styles.activeTool : ''
          )}
          onMouseEnter={() => hovraHjalpRuta()}
          onMouseLeave={() => doljHjalpRuta()}
          onClick={togglaRitverktyg}
        >
          {aktivtRitverktyg()}
        </div>
        <div className={styles.drawToolsIconsContainer}>
          <IconButton
            sx={{
              padding: '9px',
              marginLeft: 'auto',
              color: grey[800],
            }}
            onClick={() => aktiveraCirkel()}
          >
            <Cirkel isActive={ritverktyg.isCirkel} />
          </IconButton>
          <IconButton
            sx={{
              padding: '9px',
              marginLeft: 'auto',
              color: grey[800],
            }}
            onClick={() => aktiveraPolygon()}
          >
            <Polygon isActive={ritverktyg.isPolygon} />
          </IconButton>
          <IconButton
            sx={{
              padding: '9px',
              marginLeft: 'auto',
              color: grey[800],
            }}
            onClick={() => aktiveraLinje()}
          >
            <Linje isActive={ritverktyg.isLinje} />
          </IconButton>
        </div>
      </div>
    </>
  );
};

export default Ritverktyg;
